import { gql } from '@apollo/client';

const PRE_BID_SCHEDULE_CORE_FIELDS = gql`
  fragment PreBidScheduleCoreFields on PreBidSchedule {
    id
    name
    saleWeekday
    schedule {
      start
      defaultStep
      minStep
    }
  }
`;

export const PRE_BID_SCHEDULES = gql`
  ${PRE_BID_SCHEDULE_CORE_FIELDS}
  query PreBidSchedules {
    preBidSchedules {
      ...PreBidScheduleCoreFields
    }
  }
`;
